import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=4b90042f&"
import script from "./ReportPage.vue?vue&type=script&lang=js&"
export * from "./ReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReportPage.vue"
export default component.exports